import { NOLA_PHONE, locationSchema } from "../structured-data-core";

export function getSaltLakeCityStructuredData() {
  const url = "https://restorehair.com/locations/utah/salt-lake-city/";
  const description =
    "Find out about your hair transplant options in Salt Lake City with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Salt Lake City", "222 S Main St, 5th Floor", "Salt Lake City", "UT", NOLA_PHONE, url, description),
  ];
}
